const tabLinkElements = document.querySelectorAll('[data-tab]');

Array.prototype.forEach.call(tabLinkElements, (el) => {
  el.addEventListener('click', (ev) => {
    const tabParent = el.closest('.sc-general');
    const tabLinks = tabParent.querySelectorAll('[data-tab]');
    const tabContainers = tabParent.querySelectorAll('.tab-panel');
    const tabID = ev.target.getAttribute('data-tab');

    // ##################################################
    // Tab links
    // ##################################################

    Array.prototype.forEach.call(tabLinks, (elem) => {
      elem.classList.remove('is-active');
    });

    ev.target.classList.add('is-active');

    // ##################################################
    // Tab containers
    // ##################################################

    // Add active class to selected Tabs container
    Array.prototype.forEach.call(tabContainers, (elem) => {
      if (elem.classList.contains('is-active')) {
        elem.classList.remove('is-active');
      }
      if (elem.getAttribute('id') === tabID) {
        elem.classList.add('is-active');
      }
    });

    ev.target.dispatchEvent(new CustomEvent('tabChange'));
  });
});
